// extracted by mini-css-extract-plugin
export default {"FooterContent":"Footer_FooterContent__WmLjC","FooterLinks":"Footer_FooterLinks__zOlWb"};